/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.divider",
    title: "Email Divider",
    description: "A thin horizontal rule row for separating sections in platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "color": {
            title: "Color",
            type: "string",
            description: "The divider line color (hex). Defaults to a subtle gray.",
            required: false,
            default: "#E9ECEF"
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.divider",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    options = options || {};
    // Basic hex sanitation so a stray value can't inject styles.
    var color = (typeof options.color === "string" && /^#[0-9A-Fa-f]{3,8}$/.test(options.color.trim()))
        ? options.color.trim()
        : "#E9ECEF";
    var T = require("../email/Style.js").emailTheme($.config || {});
    if (T && !(typeof options.color === "string" && options.color.trim())) { color = T.rule; }

    // A zeroed font-size/line-height cell with a top border is the most
    // client-safe horizontal rule (Outlook ignores <hr> styling).
    var html = `<tr>
  <td style="padding:12px 20px;">
    <table width="100%" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td style="border-top:1px solid ${color};font-size:0;line-height:0;height:1px;">&nbsp;</td>
      </tr>
    </table>
  </td>
</tr>`;

    var text = "----------------------------------------";

    return { html, text };
};
